import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MemoRow from './row';
import { updateGrid as updateG, updateDestination } from '../../redux/bulkBookingSlice';
import { calculateErrors } from './calculateerrors';
import { getSession } from '../../global';


const Grid = () => {
    const dispatch = useDispatch();
    const { services } = useSelector(state => state.appData);
    const state = useSelector(state => { return { appData: state.appData, bulkBookingData: state.bulkBookingData } });

    const { destinations, userInfo } = state.appData;
    
    const destRef = useRef(null);
    const {
        data,
        grid,
    } = state.bulkBookingData;

    const codAmountLimit = getSession('codAmountLimit');

    const amountLimitCheck = codAmountLimit?.length > 0 && codAmountLimit?.filter(i => i.accountNo.toUpperCase() == data.accountNo.toUpperCase());
    
    let codAmountL = 99999;
    if(amountLimitCheck.length > 0) {
        codAmountL = amountLimitCheck[0].amount;
    }


    let maxAllowedWeight = data.isCod ? 99 : 9999;
                
    const codWeightLimits = getSession('codWeightLimit');

    const accountWeightLimit = codWeightLimits?.find(
        limit => limit.accountNo.toUpperCase() === data.accountNo.toUpperCase()
    );

    if (accountWeightLimit) {
        maxAllowedWeight = Math.max(maxAllowedWeight, accountWeightLimit.weight);
    }



    const updateGrid = (index, key, val) => {
        dispatch(updateG({ index, key, val }));
    };

    const updateDest = (index, val) => {
        dispatch(updateDestination({ index, val, dests: destinations }));
    }

    const findDuplicates = (CustomerReferenceNumber) => {
        const arrayForSort = [...grid]
        let sorted_grid = arrayForSort.filter(x => x.CustomerReferenceNumber && x.CustomerReferenceNumber.trim() != '').map((x, index) => ({ index, CustomerReferenceNumber: x.CustomerReferenceNumber })).sort(function (a, b) {
            return ('' + a.CustomerReferenceNumber).localeCompare(b.CustomerReferenceNumber);
        });
        let results = [];
        for (let i = 0; i < sorted_grid.length - 1; i++) {
            if (sorted_grid[i + 1].CustomerReferenceNumber == sorted_grid[i].CustomerReferenceNumber) {
                results.push(sorted_grid[i]);
            }
        }
        return results.findIndex(d => d.CustomerReferenceNumber.trim().toUpperCase() == CustomerReferenceNumber.trim().toUpperCase()) !== -1;
    }

    return <div className="row mt-2">
        <div className="table-responsive" style={{ maxHeight: "450px" }}>
            <table className="table">
                <thead>
                    <tr>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Serial No</th>
                        {
                            data.autoCN === false && <th>Consignment No</th>
                        }
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignee Name</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignee Address</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignee Mobile Number</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignee Email</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Destination City</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Pieces</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Weight</th>
                        {data.isCod && <th className="th-sticky" style={{ background: "#f5f5f5" }}>COD Amount</th>}
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Customer Reference Number</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Special Handling</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Service Type</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Product Details</th>
                        <th className="th-sticky" style={{ background: "#f5f5f5" }}>Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        grid.map((x, index) => <MemoRow 
                            destRef={destRef} key={index} x={{ ...x, isCod: data.isCod }} findDuplicates={findDuplicates} formData={data} index={index} services={services} 
                            destinations={destinations} user={userInfo} autoCN={data.autoCN} updateGrid={updateGrid} updateDest={updateDest} codAmountLimit={codAmountL} maxAllowedWeight={maxAllowedWeight}
                        />)
                    }
                </tbody>
            </table>
        </div>
    </div>
}

export default Grid;
